var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZoom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.5 4a6.5 6.5 0 1 0 4.23 11.435l4.416 4.416a.5.5 0 0 0 .708-.707l-4.416-4.416A6.5 6.5 0 0 0 10.5 4M5 10.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5.5-3a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H8a.5.5 0 0 1 0-1h2V8a.5.5 0 0 1 .5-.5"
})));
export default SvgZoom;